/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import clsx from 'clsx';
import { Form as FormikForm, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import NButton from '../../components/inputs/NButton';
import NInput from '../../components/inputs/NInput';
import useAuthHook from '../../hooks/custom-hooks/useAuthHook';
import useAuthAPI from '../../hooks/network/useAuthAPI';
import { updateUserProfileValidation } from '../../validations/validation';
import { successToaster } from '../../components/toaster/Toaster';

const formInitialValue = { phoneNumber: '', email: '', code: '' };

function UserProfile() {
  const { isAdUser, userName } = useAuthHook();
  const { getUserProfile, updateUserProfile } = useAuthAPI();

  const [userProfile, setUserProfile] = useState();
  const [message, setMessage] = useState();
  const [currentEdit, setCurrentEdit] = useState();
  const [isShowOtpDialog, setIsShowOtpDialog] = useState(false);
  const [formValue, setFormValue] = useState({ phoneNumber: '', email: '', code: '' });

  const navigate = useNavigate();

  useEffect(() => {
    if (isAdUser) navigate('/');
    fetchUserProfile();
  }, []);

  const fetchUserProfile = async () => {
    const profile = await getUserProfile();
    setFormValue({
      code: '',
      email: profile?.data?.email,
      phoneNumber: profile?.data?.phoneNumber,
    });
    setUserProfile(profile?.data);
  };

  const onSubmit = async (values) => {
    const payload = { code: values?.code };
    if (currentEdit === 'phoneNumber') {
      payload.phoneNumber = values?.phoneNumber;
    } else if (currentEdit === 'email') {
      payload.email = values?.email;
    }
    const response = await updateUserProfile(payload);
    successToaster(response?.message || 'Updated');
    setIsShowOtpDialog(false);
    setCurrentEdit(undefined);
    fetchUserProfile();
  };

  const handleEdit = async (values, type) => {
    setMessage('');
    const payload = { email: '', phoneNumber: '' };
    if (type === 'email') {
      payload.email = values?.email;
    }
    if (type === 'phoneNumber') {
      payload.phoneNumber = values?.phoneNumber;
    }
    const response = await updateUserProfile(payload);
    setMessage(response?.message);
  };

  return (
    <Formik
      initialValues={formValue}
      validationSchema={updateUserProfileValidation}
      onSubmit={(values, formikBag) => {
        onSubmit(values, formikBag);
      }}
      enableReinitialize
    >
      {({ touched, values, errors, handleSubmit, handleChange, handleBlur }) => (
        <FormikForm autoComplete='off' onSubmit={handleSubmit}>
          {isShowOtpDialog && (
            <UpdateProfileOtpDialog
              open={isShowOtpDialog}
              handleClose={() => setIsShowOtpDialog(false)}
              values={values}
              errors={errors}
              touched={touched}
              handleChange={handleChange}
              handleBlur={handleBlur}
              phoneNumber={userProfile?.phoneNumber}
              handleSubmit={handleSubmit}
              message={message}
            />
          )}
          <div className='user-profile w-ful mt-5 h-full min-h-[calc(100vh-100px)] rounded-lg bg-white px-5 pb-10 shadow-lg break:mx-20 break:px-10'>
            <div className='mb-10 border-b border-solid border-[#707070] py-4'>
              <p className='font-semibold'>Profile Setting</p>
            </div>
            <div className='flex flex-col items-center gap-5 sm:flex-row sm:gap-[100px] maclg:gap-[180px]'>
              <div
                className={clsx(
                  'flex h-[120px] w-[120px] items-center justify-center rounded-full border-2 border-solid border-white bg-nblue text-[60px] text-white',
                )}
              >
                {userName?.split(' ')?.at(0)?.charAt(0)}
              </div>
              <div>
                <p className='text-sm font-medium text-gray-400'>Full Name</p>
                <p className='font-medium text-black'>
                  {userProfile?.firstName} {userProfile?.lastName}
                </p>
              </div>
            </div>
            <div className='mt-10 flex h-[60px] flex-row items-start gap-3 sm:gap-[100px] maclg:gap-[180px]'>
              <div className='w-[80px] shrink-0 sm:w-[120px]'>
                <p className='text-sm font-medium text-gray-400'>Mobile Number</p>
              </div>
              <div className='flex w-full flex-col items-start justify-start gap-3 break:flex-row'>
                {currentEdit === 'phoneNumber' ? (
                  <>
                    <div>
                      <NInput
                        name='phoneNumber'
                        label='Mobile Number'
                        error={errors.phoneNumber && touched.phoneNumber}
                        helperText={
                          errors.phoneNumber && touched.phoneNumber ? errors.phoneNumber : ''
                        }
                        value={values?.phoneNumber}
                        placeholder='Mobile Number'
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>
                    <div className='flex items-center justify-center gap-4'>
                      <NButton onClick={() => setCurrentEdit('')} variant='Noutline'>
                        Cancel
                      </NButton>
                      <NButton
                        onClick={() => {
                          handleEdit(values, 'phoneNumber');
                          setIsShowOtpDialog(true);
                        }}
                        variant='Ncontained'
                        disabled={userProfile?.phoneNumber === values?.phoneNumber}
                      >
                        Save
                      </NButton>
                    </div>
                  </>
                ) : (
                  <>
                    <p className='text-sm font-medium text-black break:text-base'>
                      {userProfile?.phoneNumber || ''}
                    </p>
                    <div
                      className='cursor-pointer'
                      onClick={() => {
                        setCurrentEdit('phoneNumber');
                      }}
                    >
                      <ModeEditIcon />
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className='mt-10  flex h-[60px] flex-row items-start gap-3 sm:gap-[100px] maclg:gap-[180px]'>
              <div className='w-[80px] shrink-0 sm:w-[120px]'>
                <p className='text-sm font-medium text-gray-400'>Email</p>
              </div>
              <div className='flex w-full flex-col items-start justify-start gap-3 break:flex-row'>
                {currentEdit === 'email' ? (
                  <>
                    <div>
                      <NInput
                        type='email'
                        name='email'
                        label='Email'
                        value={values?.email}
                        error={errors.email && touched.email}
                        helperText={errors.email && touched.email ? errors.email : ''}
                        placeholder='Email'
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>
                    <div className='flex items-center justify-center gap-4'>
                      <NButton onClick={() => setCurrentEdit('')} variant='Noutline'>
                        Cancel
                      </NButton>
                      <NButton
                        onClick={() => {
                          handleEdit(values, 'email');
                          setIsShowOtpDialog(true);
                        }}
                        disabled={userProfile?.email === values?.email}
                        variant='Ncontained'
                      >
                        Save
                      </NButton>
                    </div>
                  </>
                ) : (
                  <>
                    <p className='break-all text-sm font-medium text-black break:text-base'>
                      {userProfile?.email || ''}
                    </p>
                    <div
                      className='cursor-pointer'
                      onClick={() => {
                        setCurrentEdit('email');
                      }}
                    >
                      <ModeEditIcon />
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className='mt-10 flex h-[60px] flex-row items-start gap-3 sm:gap-[100px] maclg:gap-[180px]'>
              <div className='w-[80px] sm:w-[120px]'>
                <p className='text-sm font-medium text-gray-400'>Customers</p>
              </div>
              <div>
                <p className='text-sm font-medium text-black break:text-base'>
                  {userProfile?.customerList?.map((c, i) => (
                    <div key={c.customerName}>{`${c.customerName}`}</div>
                  ))}
                </p>
              </div>
            </div>
            <div className='mt-10 flex h-[60px] flex-row items-start gap-3 sm:gap-[100px] maclg:gap-[180px]'>
              <div className='w-[80px] sm:w-[120px]'>
                <p className='text-sm font-medium text-gray-400'>Projects</p>
              </div>
              <div>
                <p className='text-sm font-medium text-black break:text-base'>
                  {userProfile?.customerList?.map((c, i) =>
                    c?.projectList?.map((p, pi) => (
                      <div key={p.projectName}>{`${p.projectName}`}</div>
                    )),
                  )}
                </p>
              </div>
            </div>
          </div>
        </FormikForm>
      )}
    </Formik>
  );
}

export default UserProfile;

const Transition = React.forwardRef((props, ref) => <Slide direction='up' ref={ref} {...props} />);

function UpdateProfileOtpDialog(props) {
  return (
    <div>
      <Dialog
        fullWidth
        maxWidth='xs'
        open={props?.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => props?.handleClose?.()}
        aria-describedby='alert-dialog-slide-description'
      >
        <DialogTitle className='bg-gray-200'>
          <div className='flex items-center justify-between'>
            <p className='text-base font-semibold text-black'>Verification Code</p>
            <button className='m-0 p-0' type='button' onClick={() => props?.handleClose?.()}>
              <CloseIcon />
            </button>
          </div>
        </DialogTitle>
        <div className='flex flex-col items-center justify-center p-8'>
          <div className='mb-5 text-center font-medium text-black'>{props?.message}</div>
          <div className='mb-10'>
            <NInput
              type='text'
              name='code'
              label='OTP'
              value={props?.values?.code}
              error={props?.errors.code && props?.touched.code}
              helperText={props?.errors.code && props?.touched.code ? props?.errors.code : ''}
              placeholder='OTP'
              onChange={props?.handleChange}
              onBlur={props?.handleBlur}
            />
          </div>
          <div>
            <NButton type='submit' onClick={() => props?.handleSubmit?.()} variant='Ncontained'>
              Submit
            </NButton>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
